"use strict";

exports.__esModule = true;
var _AlertWatcherRuleListScreen = require("./AlertWatcherRuleListScreen");
Object.keys(_AlertWatcherRuleListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertWatcherRuleListScreen[key]) return;
  exports[key] = _AlertWatcherRuleListScreen[key];
});